module.exports = __webpack_public_path__ + "img/f_5.5702870d.png";